import { ThemeProperties } from '../../../core';

export interface TextAreaTheme {
	baseBorderColor: string;
	basePaddingHorizontal: string;
	basePaddingVertical: string;
	baseFont: string;
	baseTextColor: string;
	baseBorderRadius: string;
	baseBackground: string;
	baseMinHeight: string;

	focusRingColor: string;

	hoverBorderColor: string;

	readOnlyBackground: string;
	readOnlyBorderColor: string;

	placeholderTextColor: string;

	highlightBackground: string;
	highlightBorderColor: string;
	highlightHoverBorderColor: string;
	highlightPlaceholderTextColor: string;

	invalidBorderColor: string;
	invalidPaddingRight: string;
	invalidIconColor: string;
	invalidIconSize: string;
}
export const theme = new ThemeProperties('textArea');
